// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"292":"7dad99de902089d4","642":"ddf7aa92949ab0c3","881":"3cb1fc610db81599","934":"f7428ebbf48c4302"}[chunkId] + ".js";
};